import { useContext } from 'react';
import { Context } from './configContext';

/**
 * @typedef { import('./useConfig.types').FeatureFlags } Features
 * @returns {{ featureActions: any, featuresProviders: any, features: Features }}
 */
export function useConfig() {
  const { state: fullState = {}, actions: featureActions } = useContext(Context);
  const { providersReady, errors, ...features } = fullState;

  return {
    errors,
    featureActions,
    features,
    featuresProviders: providersReady,
  };
}

export default useConfig;
